

import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Catalog from '../Components/CoursePages/Catalog'
import Catalog2 from '../Components/CoursePages/Catalog2'
import { IoGrid } from 'react-icons/io5'
import { FaListUl, FaArrowUp } from 'react-icons/fa'
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'

// Custom Dropdown Toggle with inline styles
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=' '
    ref={ref}
    onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
    style={{
      display: 'inline-block',
      padding: '8px 20px',
      backgroundColor: '#f8f9fa',
      border: '1px solid #ddd',
      borderRadius: '20px 20px 0 0',
      color: '#333',
      textDecoration: 'none',
      fontWeight: '500',
      marginRight: '5px',
      transition: 'all 0.3s ease',
      boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      position: 'relative',
      borderBottom: 'none',
      cursor: 'pointer',
    }}
  >
    {children}
    <span style={{ fontSize: '0.7em', marginLeft: '5px' }}>▼</span>
  </a>
))

// Custom Dropdown Menu with inline styles
const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    const [value, setValue] = useState('')

    return (
      <div
        ref={ref}
        style={{
          ...style,
          backgroundColor: '#fff',
          borderRadius: '0 15px 15px 15px',
          border: '1px solid #ddd',
          borderTop: 'none',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          padding: '10px 0',
          marginTop: '-1px',
        }}
        className={className}
        aria-labelledby={labeledBy}
      >
        <Form.Control
          autoFocus
          className='mx-3 my-2 w-auto'
          placeholder='Type to filter...'
          onChange={(e) => setValue(e.target.value)}
          value={value}
          style={{ borderRadius: '10px' }}
        />
        <ul className='list-unstyled'>
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value)
          )}
        </ul>
      </div>
    )
  }
)

export default function MyCourses() {
  const [viewType, setViewType] = useState('grid')
  const [loading, setLoading] = useState(false)
  const [courses, setCourses] = useState([])
  const [enrolledCourses, setEnrolledCourses] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [categories, setCategories] = useState([])
  const [filterType, setFilterType] = useState('all')
  const [showBackToTop, setShowBackToTop] = useState(false)

  useEffect(() => {
    // const apiUrl = 'https://kaasbackend.vetrinahealthcare.com/lms/courses/'
    const apiUrl = 'https://kaasbackend.vetrinahealthcare.com/lms/courses/'
    const token = localStorage.getItem('jwttoken')

    const fetchCourses = async () => {
      setLoading(true)
      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        })
        setCourses([...response.data.courses])
        setEnrolledCourses(
          response.data.courses.filter((course) => course.enrolled)
        )
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error)
      } finally {
        setLoading(false)
      }
    }

    const fetchCategories = async () => {
      try {
        const response = await axios.get(
          'https://kaasbackend.vetrinahealthcare.com/lms/categories/',
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )
        setCategories([...response.data])
      } catch (error) {
        console.error('Failed to fetch categories:', error)
      }
    }

    fetchCourses()
    fetchCategories()

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleScroll = () => {
    if (window.pageYOffset > 300) {
      setShowBackToTop(true)
    } else {
      setShowBackToTop(false)
    }
  }

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  const filteredCourses = courses.filter((course) => {
    const isEnrolled = filterType === 'enrolled' ? course.enrolled : true
    return (
      course.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (!selectedCategory ||
        course.categories.indexOf(selectedCategory) !== -1) &&
      isEnrolled
    )
  })

  return (
    <div>
      <Header />
      <div
        className='container Full_Width_Container'
        style={{ marginTop: '100px' }}
      >
        {/* Enrolled Courses Section */}
        <div className='row'>
          <div className='col-sm-12 text-center'>
            <div
              className='text-center border rounded mx-auto text-light mb-4 p-1'
              style={{
                background:
                  'linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)',
                width: '80%',
                maxWidth: '350px',
              }}
            >
              <h1 className='Catlog_Heading'>
                <b>My Courses</b>
              </h1>
            </div>
            {/* <h4 className="Catlog_Text my-3">
              <b>Continue Your Learning Journey</b>
            </h4> */}
          </div>
        </div>

        {loading ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{ minHeight: '200px' }}
          >
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <div className='grid-view'>
            <div className='row mt-2 freecard'>
              {enrolledCourses.length > 0 ? (
                enrolledCourses.map((course) => (
                  <div className='col-sm-4 mb-4' key={course.course_id}>
                    <Catalog
                      coursetitle={course.title}
                      numlesson={`categories:-  ${course.categories} `}
                      courseId={course.course_id}
                      price={course.price}
                      instructor={course.instructor.name}
                      enrolled={true}
                    />
                  </div>
                ))
              ) : (
                <div
                  className='col-sm-12 text-center py-5'
                  style={{
                    opacity: 0,
                    animation: 'fadeIn 0.8s ease-out forwards',
                    animationDelay: '0.3s',
                  }}
                >
                  <div
                    style={{
                      maxWidth: '500px',
                      margin: '0 auto',
                      padding: '30px',
                      borderRadius: '15px',
                      background: '#f9f9f9',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                    }}
                  >
                    <img
                      src='https://cdn-icons-png.flaticon.com/512/4076/4076478.png'
                      alt='No courses'
                      style={{
                        width: '120px',
                        marginBottom: '20px',
                        filter: 'hue-rotate(180deg)',
                        opacity: 0.8,
                      }}
                    />
                    <h4
                      style={{
                        marginBottom: '15px',
                        color: '#333',
                        fontWeight: '600',
                      }}
                    >
                      No Courses Enrolled Yet
                    </h4>
                    <p
                      style={{
                        color: '#666',
                        marginBottom: '25px',
                        fontSize: '16px',
                      }}
                    >
                      You haven't enrolled in any courses yet. Start your
                      learning journey today!
                    </p>
                    <button
                      className='btn'
                      style={{
                        padding: '12px 30px',
                        borderRadius: '30px',
                        background: 'linear-gradient(135deg, #3953A3, #B8529E)',
                        border: 'none',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: '600',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(57, 83, 163, 0.3)',
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)'
                        e.currentTarget.style.boxShadow =
                          '0 6px 20px rgba(57, 83, 163, 0.4)'
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)'
                        e.currentTarget.style.boxShadow =
                          '0 4px 15px rgba(57, 83, 163, 0.3)'
                      }}
                      onClick={() =>
                        window.scrollTo({
                          top:
                            document.querySelector('.input-group-Course')
                              .offsetTop - 100,
                          behavior: 'smooth',
                        })
                      }
                    >
                      Explore Courses
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Rest of your component remains the same */}
        {/* Explore Courses Section */}
        <div className='row mt-5'>
          <div className='col-sm-12 text-center'>
            {/* <div
              className="text-center border rounded mx-auto text-light mb-4 p-1"
              style={{
                background: "linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)",
                width: "80%",
                maxWidth: "350px",
              }}
            >
              <h1 className="Catlog_Heading">
                <b>Explore Courses</b>
              </h1>
            </div> */}
            {/* <h4 className="Catlog_Text my-3">
              <b>Get Your Skills Up! Extremely Free</b>
            </h4> */}
            <div
              className='input-group-Course'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '20px 0',
              }}
            >
              <input
                type='search'
                className='form-control'
                placeholder='Just Search Your Wish'
                aria-label='Search'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: '80%',
                  padding: '10px 15px',
                  fontSize: '16px',
                  borderRadius: '20px',
                  border: '1px solid #ccc',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  outline: 'none',
                  transition: 'border-color 0.3s, box-shadow 0.3s',
                }}
              />
            </div>
          </div>
        </div>

        {/* Filters Container with Tab-like Dropdowns */}
        <div
          className='container py-4 mb-3'
          style={{ marginTop: '0', paddingTop: '0' }}
        >
          <div
            className='row d-flex justify-content-between py-2'
            style={{ gap: '0px' }}
          >
            <div className='col-sm-7'>
              <div className='row'>
                <div className='col-sm-4'>
                  <Dropdown>
                    <Dropdown.Toggle as={CustomToggle} id='dropdown-courses'>
                      {filterType === 'all'
                        ? 'All Courses'
                        : 'Enrolled Courses'}
                    </Dropdown.Toggle>
                    <Dropdown.Menu as={CustomMenu}>
                      <Dropdown.Item
                        onClick={() => setFilterType('all')}
                        style={{ padding: '8px 20px', color: '#333' }}
                      >
                        All Courses
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => setFilterType('enrolled')}
                        style={{ padding: '8px 20px', color: '#333' }}
                      >
                        Enrolled Courses
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div className='col-sm-4'>
                  <Dropdown>
                    <Dropdown.Toggle as={CustomToggle} id='dropdown-categories'>
                      {selectedCategory === ''
                        ? 'All Categories'
                        : selectedCategory}
                    </Dropdown.Toggle>
                    <Dropdown.Menu as={CustomMenu}>
                      <Dropdown.Item
                        onClick={() => setSelectedCategory('')}
                        style={{ padding: '8px 20px', color: '#333' }}
                      >
                        All Categories
                      </Dropdown.Item>
                      {categories.map((category) => (
                        <Dropdown.Item
                          key={category.category_id}
                          onClick={() => setSelectedCategory(category.name)}
                          style={{ padding: '8px 20px', color: '#333' }}
                        >
                          {category.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className='col-sm-5'>
              <div className='row justify-content-end'>
                <div className='col-sm-2 d-flex justify-content-end'>
                  <button
                    className='grid'
                    onClick={() => setViewType('list')}
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #ddd',
                      borderRadius: '20px',
                      padding: '8px 12px',
                      margin: '0 5px',
                      cursor: 'pointer',
                    }}
                  >
                    <FaListUl />
                  </button>
                </div>
                <div className='col-sm-2 d-flex justify-content-end'>
                  <button
                    className='grid'
                    onClick={() => setViewType('grid')}
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #ddd',
                      borderRadius: '20px',
                      padding: '8px 12px',
                      margin: '0 5px',
                      cursor: 'pointer',
                    }}
                  >
                    <IoGrid />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Courses Display */}
        {loading ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{ minHeight: '200px' }}
          >
            <div className='spinner-border text-primary' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {viewType === 'grid' ? (
              <div className='grid-view'>
                <div className='row mt-2 freecard'>
                  {filteredCourses.length > 0 ? (
                    filteredCourses.map((course) => (
                      <div className='col-sm-4 mb-4' key={course.course_id}>
                        <Catalog
                          coursetitle={course.title}
                          numlesson={`categories:-  ${course.categories} `}
                          courseId={course.course_id}
                          price={course.price}
                          instructor={course.instructor.name}
                        />
                      </div>
                    ))
                  ) : (
                    <div className='col-sm-12'>No Courses Available</div>
                  )}
                </div>
              </div>
            ) : (
              <div className='list-view' style={{ border: '0px' }}>
                <div className='list-group mt-2' style={{ border: '0%' }}>
                  {filteredCourses.length > 0 ? (
                    filteredCourses.map((course) => (
                      <div className='list-group-item' key={course.course_id}>
                        <Catalog2
                          coursetitle={course.title}
                          courseId={course.course_id}
                          description={course.description}
                          start_date={course.start_date}
                          instructor={course.instructor.name}
                        />
                      </div>
                    ))
                  ) : (
                    <div>No Courses Available</div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          type='button'
          onClick={goToTop}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            backgroundColor: '#3953A3',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '20px',
            transition: 'all 0.3s ease',
            zIndex: 1000,
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#B8529E'
            e.currentTarget.style.transform = 'scale(1.1)'
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#3953A3'
            e.currentTarget.style.transform = 'scale(1)'
          }}
        >
          <FaArrowUp />
        </button>
      )}

      <Footer />
      <style>{`
        @keyframes fadeIn {
          from { 
            opacity: 0; 
            transform: translateY(20px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }
      `}</style>
    </div>
  )
}
